export default "__VITE_ASSET__CWJ1nk2y__"